/** Client-side SMS billing helpers (₹ per successful send). */

export const DEFAULT_SMS_UNIT_COST_INR = 0.25;

export function smsUnitCost(unit?: number | null): number {
  const n = Number(unit);
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_SMS_UNIT_COST_INR;
}

/**
 * Prefer API cost when it is a positive number; otherwise recompute from count × unit.
 * Fixes super-admin showing ₹0.00 when the server returned unitCost 0 / missing cost.
 */
export function smsRangeCostInr(sent: number, unit?: number | null, apiCost?: number | null): number {
  const count = Math.max(0, Number(sent) || 0);
  const u = smsUnitCost(unit);
  const api = Number(apiCost);
  if (Number.isFinite(api) && api > 0) return Number(api.toFixed(2));
  return Number((count * u).toFixed(2));
}
